import { render, staticRenderFns } from "./globalModals.vue?vue&type=template&id=f1a823ec&functional=true"
var script = {}
import style0 from "./globalModals.vue?vue&type=style&index=0&id=f1a823ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports